// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1AWDv","right":"styles_right__6ogku"};